export const APP_CONFIG_SET = 'APP_CONFIG_SET';
export const APP_SETUP_CONFIGURE = 'APP_SETUP_CONFIGURE';
export const APP_MODE_SET = 'APP_MODE_SET';
export const APP_CHANGE_DEFAULT_MERCHANT_ID = 'APP_CHANGE_DEFAULT_MERCHANT_ID';

export const APP_SETUP_CHANGE_CUSTOMER = 'APP_SETUP_CHANGE_CUSTOMER';
export const APP_SETUP_CHANGE_PERSONA = 'APP_SETUP_CHANGE_PERSONA';
export const APP_SETUP_CHANGE_BILLING_ADDRESS = 'APP_SETUP_CHANGE_BILLING_ADDRESS';
export const APP_SETUP_CHANGE_SHIPPING_ADDRESS = 'APP_SETUP_CHANGE_SHIPPING_ADDRESS';

export const setAppConfig = (result, appMode) => (dispatch) => {
  dispatch({type: APP_CONFIG_SET, value: result});
  dispatch({type: APP_MODE_SET, value: appMode});
  dispatch({type: APP_CHANGE_DEFAULT_MERCHANT_ID, value: result.environment.merchantId});
};



// WEBPACK FOOTER //
// ./src/app/AppActions.js